// #162870

// rgba(225, 245, 255, 1)

import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";

const useThemeTitleStyles = makeThemedStyles("ThemeTitle", (theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "13px",
    color: "white",
    background: "linear-gradient(#162870aa, #162870ff)",
    overflow: "hidden",
    borderRadius: "8px",
    minHeight: "30px",
    padding: "0px 0px 0px 3px",
  },
}));

const ThemeTitle = (
  props: React.PropsWithChildren<{ background?: string; textColor?: string }>
) => {
  const styles = useThemeTitleStyles();
  return (
    <div
      className={styles.root}
      style={{ background: props.background, color: props.textColor }}
    >
      {props.children}
    </div>
  );
};

export default ThemeTitle;
